import React from 'react';

const Facebook = () => (
  <svg className="SocialIcon-svgIcon SocialIcon-facebook" width="24" height="24" viewBox="0 0 24 24">
    <path className="fill" d="M12,0C5.4,0,0,5.4,0,12c0,6.6,5.4,12,12,12s12-5.4,12-12C24,5.4,18.6,0,12,0z M15.4,7.4l-1.2,0
      c-1,0-1.2,0.5-1.2,1.1V10h2.3l-0.3,2.4h-2v6h-2.4v-6h-2V10h2V8.3c0-2,1.2-3.1,3-3.1c0.9,0,1.6,0.1,1.8,0.1V7.4z"/>
  </svg>
);

export default Facebook;



// WEBPACK FOOTER //
// ./app/components/icons/Facebook.js